module.exports = __webpack_public_path__ + "img/michelle-obama.6afe3645.png";